// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"2942":"33a90913","3872":"3a0e3154","7104":"d02c5a98","7195":"3a0e3154"}[chunkId] + ".chunk.css";
};